import $ from '@nuskin/nuskinjquery';
import {shopModule} from '../../module.js';

shopModule.directive('clickable', [function() {
    return {
        restrict: 'A',
        scope: {
            actionfn: "&"
        },
        link: function(scope, element) {
            let pendingTouchMove = false;

            let clickFunction = function(event) {
                if (element.context && $('#' + element.context.id).length > 0) {
                    if(!pendingTouchMove) {
                        scope.actionfn({event: event});
                    }
                    pendingTouchMove = false;
                }
            };

            let moveFunction = function() {
                // Set up a pending touch move. This prevents a "touch scroll"
                // from beind interpreted as an intent to close
                pendingTouchMove = true;
            };

            $(document).off('click touchend');
            $(document).off('touchmove');

            $(document).on('click touchend', clickFunction);
            $(document).on('touchmove', moveFunction);
        }
    }
}]);
